/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Reminder_OffInputs */

const en_us2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

const pt_br2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligado`)
};

const es_419_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivado`)
};

const pt_pt2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligado`)
};

const fr_fr2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé`)
};

const de_de2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus`)
};

const it_it2_profile_reminder_off = /** @type {(inputs: Profile_Reminder_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattivato`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Profile_Reminder_OffInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_off = /** @type {((inputs?: Profile_Reminder_OffInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_OffInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_off(inputs)
	if (locale === "es-419") return es_419_profile_reminder_off(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_off(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_off(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_off(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_off(inputs)
	return en_us2_profile_reminder_off(inputs)
});
export { profile_reminder_off as "profile.reminder_off" }